const isActiveParam = (key, value) => window.location.search.indexOf(`${key}=${value}`) !== -1;

const isActivePath = (path) => window.location.pathname.indexOf(path) !== -1;

export { isActiveParam, isActivePath };
